






































































































































































































































import Vue from 'vue'
// @ts-ignore
import _ from 'lodash'
import { TranslateResult } from 'vue-i18n'
import { SnackbarStateEnum } from '@/types/enums'
import moment from 'moment'
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import NumberField from '@/components/NumberField.vue'


interface ComponentData {
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  valid: boolean
  validationRules: Array<Function>
  nullableDateRules: Array<Function>

  Lager: any
  Lagerfach: any
  Bevorzugt: any
  Laenge: number | null
  Hoehe: number | null
  Breite: number | null
  Gewicht: number | null
  Bestand: number | null
  Einheit: any
  Bestellt: number | null
  Reserviert: number | null
  Leitwaehrung: any
  Ertrag: any
  Aufwand: any
  Warenvorrat: any
  HauptKTR: any
  NebenKTR: any
  LagerKST: any
  WiAKST: any
  EinkaufsPreis: number | null
  EinkaufsPreisDatum: string | null
  EinkaufsPreisDatumFormatted: string | null
  LetzterEPBasisWaehrung: number | null
  LetzterEPDatum: string | null
  LetzterEPDatumFormatted: string | null
  LetzterEP: number | null
  LetzterEPWaehrung: any
  InventarPreis: number | null
  InventarPreisDatum: string | null
  InventarPreisDatumFormatted: string | null
  KalkulationsPreis: number | null
  KalkulationsPreisDatum: string | null
  KalkulationsPreisDatumFormatted: string | null
  menu1: boolean
  menu2: boolean
  menu3: boolean
  menu4: boolean
}

export default Vue.extend({
  name: 'ProductStorage',

  components: {
    NumberField
  },

  props: {
    productId: Number,
    selectedProductUnitId: Number,
    selectedLagerungenId: Number,
    storageMetaData: Object as () => any,
    storageData: Object as () => any,
    isCreate: Boolean,
    isUpdate: Boolean,
    loading: Boolean
  },

  data (): ComponentData {
    const required = (value: any): boolean | string => !!value || ''

    return {
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      valid: true,
      validationRules: [required],
      nullableDateRules: [
        (value: string) => {
          const pattern = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
          return value ? value.length >= 1 ? pattern.test(value) || this.$t('errors.wrongDate').toString() : true : true
        }
      ],

      Lager: null,
      Lagerfach: null,
      Bevorzugt: null,
      Laenge: null,
      Hoehe: null,
      Breite: null,
      Gewicht: null,
      Bestand: null,
      Einheit: null,
      Bestellt: null,
      Reserviert: null,
      Leitwaehrung: null,
      Ertrag: null,
      Aufwand: null,
      Warenvorrat: null,
      HauptKTR: null,
      NebenKTR: null,
      LagerKST: null,
      WiAKST: null,
      EinkaufsPreis: null,
      EinkaufsPreisDatum: null,
      EinkaufsPreisDatumFormatted: '',
      LetzterEPBasisWaehrung: null,
      LetzterEPDatum: null,
      LetzterEPDatumFormatted: '',
      LetzterEP: null,
      LetzterEPWaehrung: null,
      InventarPreis: null,
      InventarPreisDatum: null,
      InventarPreisDatumFormatted: '',
      KalkulationsPreis: null,
      KalkulationsPreisDatum: null,
      KalkulationsPreisDatumFormatted: '',
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false
    }
  },

  watch: {
    isCreate (newVal: boolean): void {
      if(newVal) {
        this.resetData()
        setTimeout(() => {
          const focusedField: any = this.$refs['focusedField']
          if (focusedField) {
            focusedField.focus()
          }
        }, 0)
      }
    },

    isUpdate (newVal: boolean): void {
      if(newVal) {
        setTimeout(() => {
          const focusedField: any = this.$refs['focusedField']
          if (focusedField) {
            focusedField.focus()
          }
        }, 0)
      }
    },

    storageData (newVal: any): void {
      if(newVal) {
        this.setData()
      }
    },

    EinkaufsPreisDatumFormatted (newVal: string | null): void {
      if(newVal) {
        this.EinkaufsPreisDatum = moment(newVal, 'DD.MM.YYYY').isValid() ? moment(newVal, 'DD.MM.YYYY').format('YYYY-MM-DD'): null
      } else {
        this.EinkaufsPreisDatum = null
      }
    },

    LetzterEPDatumFormatted (newVal: string | null): void {
      if(newVal) {
        this.LetzterEPDatum = moment(newVal, 'DD.MM.YYYY').isValid() ? moment(newVal, 'DD.MM.YYYY').format('YYYY-MM-DD'): null
      } else {
        this.LetzterEPDatum = null
      }
    },

    InventarPreisDatumFormatted (newVal: string | null): void {
      if(newVal) {
        this.InventarPreisDatum = moment(newVal, 'DD.MM.YYYY').isValid() ? moment(newVal, 'DD.MM.YYYY').format('YYYY-MM-DD'): null
      } else {
        this.InventarPreisDatum = null
      }
    },

    KalkulationsPreisDatumFormatted (newVal: string | null): void {
      if(newVal) {
        this.KalkulationsPreisDatum = moment(newVal, 'DD.MM.YYYY').isValid() ? moment(newVal, 'DD.MM.YYYY').format('YYYY-MM-DD'): null
      } else {
        this.KalkulationsPreisDatum = null
      }
    }
  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    selectedLocale(): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },

    isReadonlyFields (): boolean {
      if(this.isCreate || this.isUpdate) {
        return false
      } else {
        return true
      }
    },

    getKontenErtrag (): any {
      return _.orderBy(this.storageMetaData.KontenErtrag.map((item: any) => {
        item.Label = `${item.Nummer} ${item.Bezeichnung}`
        return item
      }), ['Nummer'], ['asc'])
    },

    getKontenAufwand (): any {
      return _.orderBy(this.storageMetaData.KontenAufwand.map((item: any) => {
        item.Label = `${item.Nummer} ${item.Bezeichnung}`
        return item
      }), ['Nummer'], ['asc'])
    },

    getKontenAktiven (): any {
      return _.orderBy(this.storageMetaData.KontenAktiven.map((item: any) => {
        item.Label = `${item.Nummer} ${item.Bezeichnung}`
        return item
      }), ['Nummer'], ['asc'])
    },

    getKontenKostentraeger (): any {
      return _.orderBy(this.storageMetaData.KontenKostentraeger.map((item: any) => {
        item.Label = `${item.Nummer} ${item.Bezeichnung}`
        return item
      }), ['Nummer'], ['asc'])
    },

    getKontenKostenstellen (): any {
      return _.orderBy(this.storageMetaData.KontenKostenstellen.map((item: any) => {
        item.Label = `${item.Nummer} ${item.Bezeichnung}`
        return item
      }), ['Nummer'], ['asc'])
    }
  },

  methods: {
    onBlurEinkaufsPreisDatum (): void {
      this.EinkaufsPreisDatumFormatted = this.EinkaufsPreisDatum && moment(this.EinkaufsPreisDatum).isValid() ? moment(this.EinkaufsPreisDatum).format('DD.MM.YYYY') : ''
      setTimeout(() => {
        if(this.menu1) {
          this.menu1 = false
        }
      }, 100)
    },

    onBlurLetzterEPDatum (): void {
      this.LetzterEPDatumFormatted = this.LetzterEPDatum && moment(this.LetzterEPDatum).isValid() ? moment(this.LetzterEPDatum).format('DD.MM.YYYY') : ''
      setTimeout(() => {
        if(this.menu2) {
          this.menu2 = false
        }
      }, 100)
    },

    onBlurInventarPreisDatum (): void {
      this.InventarPreisDatumFormatted = this.InventarPreisDatum && moment(this.InventarPreisDatum).isValid() ? moment(this.InventarPreisDatum).format('DD.MM.YYYY') : ''
      setTimeout(() => {
        if(this.menu3) {
          this.menu3 = false
        }
      }, 100)
    },

    onBlurKalkulationsPreisDatum (): void {
      this.KalkulationsPreisDatumFormatted = this.KalkulationsPreisDatum && moment(this.KalkulationsPreisDatum).isValid() ? moment(this.KalkulationsPreisDatum).format('DD.MM.YYYY') : ''
      setTimeout(() => {
        if(this.menu4) {
          this.menu4 = false
        }
      }, 100)
    },
    /*onLaengeChange (item: string): void {
      this.Laenge = parseFloat(item.replace(',', '.')).toFixed(3)
    },*/
    onLaengeChange (): void {
      if(this.Laenge && this.Laenge < 0) {
        this.Laenge = null
      }
    },
    onHoeheChange (): void {
      if(this.Hoehe && this.Hoehe < 0) {
        this.Hoehe = null
      }
    },
    onBreiteChange (): void {
      if(this.Breite && this.Breite < 0) {
        this.Breite = null
      }
    },
    onGewichtChange (): void {
      if(this.Gewicht && this.Gewicht < 0) {
        this.Gewicht = null
      }
    },

    onInventarPreisChange (): void {
      if(this.InventarPreis && this.InventarPreis < 0) {
        this.InventarPreis = null
      }
    },

    onKalkulationsPreisChange (): void {
      if(this.KalkulationsPreis && this.KalkulationsPreis < 0) {
        this.KalkulationsPreis = null
      }
    },

    onEinkaufsPreisDatumChange (date: string): void {
      if(date && date.length > 0) {
        this.EinkaufsPreisDatumFormatted = moment(date).format('DD.MM.YYYY')
      } else {
        this.EinkaufsPreisDatumFormatted = null
      }
    },

    onLetzterEPDatumChange (date: string): void {
      if(date && date.length > 0) {
        this.LetzterEPDatumFormatted = moment(date).format('DD.MM.YYYY')
      } else {
        this.LetzterEPDatumFormatted = null
      }
    },

    onInventarPreisDatumChange (date: string): void {
      if(date && date.length > 0) {
        this.InventarPreisDatumFormatted = moment(date).format('DD.MM.YYYY')
      } else {
        this.InventarPreisDatumFormatted = null
      }
    },

    onKalkulationsPreisDatumChange (date: string): void {
      if(date && date.length > 0) {
        this.KalkulationsPreisDatumFormatted = moment(date).format('DD.MM.YYYY')
      } else {
        this.KalkulationsPreisDatumFormatted = null
      }
    },

    onCancelClick (): void {
      this.setData()
      this.$emit('onCancelClick')
    },

    upsertProductStorage (): void {
      const form: any = this.$refs['form']
      if(form.validate()) {
        if (this.isCreate) {
          const payload: any = {
            Produkt: this.productId,
            Lagerung: this.isCreate ? 0 : this.selectedLagerungenId,
            Lager: this.Lager,
            Lagerfach: this.Lagerfach,
            Bevorzugt: this.Bevorzugt,
            Laenge: this.Laenge,
            Hoehe: this.Hoehe,
            Breite: this.Breite,
            Gewicht: this.Gewicht,
            Bestand: this.Bestand,
            Einheit: this.Einheit,
            Bestellt: this.Bestellt,
            Reserviert: this.Reserviert,
            Leitwaehrung: this.Leitwaehrung,
            Ertrag: this.Ertrag,
            Aufwand: this.Aufwand,
            Warenvorrat: this.Warenvorrat,
            HauptKTR: this.HauptKTR,
            NebenKTR: this.NebenKTR,
            LagerKST: this.LagerKST,
            WiAKST: this.WiAKST,
            EinkaufsPreis: this.EinkaufsPreis,
            EinkaufsPreisDatum: this.EinkaufsPreisDatum,
            LetzterEPBasisWaehrung: this.LetzterEPBasisWaehrung,
            LetzterEPDatum: this.LetzterEPDatum,
            LetzterEP: this.LetzterEP,
            LetzterEPWaehrung: this.LetzterEPWaehrung,
            InventarPreis: this.InventarPreis,
            InventarPreisDatum: this.InventarPreisDatum,
            KalkulationsPreis: this.KalkulationsPreis,
            KalkulationsPreisDatum: this.KalkulationsPreisDatum,
            VerbrauchCalcDat: moment().format('YYYY-MM-DD HH:mm:ss')
          }
          this.$emit('upsertProductStorage', payload)
        } else if (this.isUpdate) {
          let payload = this.storageData.Lagerung[0]
          payload.Produkt = this.productId
          payload.Lagerung = payload.ID
          payload.Lager = this.Lager
          payload.Lagerfach = this.Lagerfach
          payload.Bevorzugt = this.Bevorzugt
          payload.Laenge = this.Laenge
          payload.Hoehe = this.Hoehe
          payload.Breite = this.Breite
          payload.Gewicht = this.Gewicht
          payload.Bestand = this.Bestand
          payload.Einheit = this.Einheit
          payload.Bestellt = this.Bestellt
          payload.Reserviert = this.Reserviert
          payload.Leitwaehrung = this.Leitwaehrung
          payload.Ertrag = this.Ertrag
          payload.Aufwand = this.Aufwand
          payload.Warenvorrat = this.Warenvorrat
          payload.HauptKTR = this.HauptKTR
          payload.NebenKTR = this.NebenKTR
          payload.LagerKST = this.LagerKST
          payload.WiAKST = this.WiAKST
          payload.EinkaufsPreis = this.EinkaufsPreis
          payload.EinkaufsPreisDatum = this.EinkaufsPreisDatum
          payload.LetzterEPBasisWaehrung = this.LetzterEPBasisWaehrung
          payload.LetzterEPDatum = this.LetzterEPDatum
          payload.LetzterEP = this.LetzterEP
          payload.LetzterEPWaehrung = this.LetzterEPWaehrung
          payload.InventarPreis = this.InventarPreis
          payload.InventarPreisDatum = this.InventarPreisDatum
          payload.KalkulationsPreis = this.KalkulationsPreis
          payload.KalkulationsPreisDatum = this.KalkulationsPreisDatum
          //payload.VerbrauchCalcDat = moment().format('YYYY-MM-DD HH:mm:ss')
          this.$emit('upsertProductStorage', payload)
        }
      }
    },

    setData (): void {
      this.Lager = this.storageData && this.storageData.Lagerung[0] ? this.storageData.Lagerung[0].Lager : null
      this.Lagerfach = this.storageData && this.storageData.Lagerung[0] ? this.storageData.Lagerung[0].Lagerfach : null
      this.Bevorzugt = this.storageData && this.storageData.Lagerung[0] ? this.storageData.Lagerung[0].Bevorzugt : false
      this.Laenge = this.storageData && this.storageData.Lagerung[0] ? this.storageData.Lagerung[0].Laenge !== null ? parseFloat(parseFloat(this.storageData.Lagerung[0].Laenge).toFixed(3)) : null : null
      this.Hoehe = this.storageData && this.storageData.Lagerung[0] ? this.storageData.Lagerung[0].Hoehe !== null ? parseFloat(parseFloat(this.storageData.Lagerung[0].Hoehe).toFixed(3)) : null : null
      this.Breite = this.storageData && this.storageData.Lagerung[0] ? this.storageData.Lagerung[0].Breite !== null ? parseFloat(parseFloat(this.storageData.Lagerung[0].Breite).toFixed(3)) : null : null
      this.Gewicht = this.storageData && this.storageData.Lagerung[0] ? this.storageData.Lagerung[0].Gewicht !== null ? parseFloat(parseFloat(this.storageData.Lagerung[0].Gewicht).toFixed(3)) : null : null
      this.Bestand = this.storageData && this.storageData.Lagerung[0] ? this.storageData.Lagerung[0].Bestand !== null ? parseFloat(parseFloat(this.storageData.Lagerung[0].Bestand).toFixed(3)) : null : null
      this.Einheit = this.storageData && this.storageData.Lagerung[0] ? this.storageData.Lagerung[0].Einheit : null
      this.Bestellt = this.storageData && this.storageData.Lagerung[0] ? this.storageData.Lagerung[0].Bestellt !== null ? parseFloat(parseFloat(this.storageData.Lagerung[0].Bestellt).toFixed(3)) : null : null
      this.Reserviert = this.storageData && this.storageData.Lagerung[0] ? this.storageData.Lagerung[0].Reserviert !== null ? parseFloat(parseFloat(this.storageData.Lagerung[0].Reserviert).toFixed(3)) : null : null
      this.Leitwaehrung = this.storageData && this.storageData.Lagerung[0] ? this.storageData.Lagerung[0].Leitwaehrung : null
      this.Ertrag = this.storageData && this.storageData.Lagerung[0] ? this.storageData.Lagerung[0].Ertrag : null
      this.Aufwand = this.storageData && this.storageData.Lagerung[0] ? this.storageData.Lagerung[0].Aufwand : null
      this.Warenvorrat = this.storageData && this.storageData.Lagerung[0] ? this.storageData.Lagerung[0].Warenvorrat : null
      this.HauptKTR = this.storageData && this.storageData.Lagerung[0] ? this.storageData.Lagerung[0].HauptKTR : null
      this.NebenKTR = this.storageData && this.storageData.Lagerung[0] ? this.storageData.Lagerung[0].NebenKTR : null
      this.LagerKST = this.storageData && this.storageData.Lagerung[0] ? this.storageData.Lagerung[0].LagerKST : null
      this.WiAKST = this.storageData && this.storageData.Lagerung[0] ? this.storageData.Lagerung[0].WiAKST : null
      this.EinkaufsPreis = this.storageData && this.storageData.Lagerung[0] ? this.storageData.Lagerung[0].EinkaufsPreis !== null ? parseFloat(parseFloat(this.storageData.Lagerung[0].EinkaufsPreis).toFixed(2)) : null : null
      this.EinkaufsPreisDatum = this.storageData && this.storageData.Lagerung[0] ? this.storageData.Lagerung[0].EinkaufsPreisDatum : null
      this.EinkaufsPreisDatumFormatted = this.storageData && this.storageData.Lagerung[0] && this.storageData.Lagerung[0].EinkaufsPreisDatum ? moment(this.storageData.Lagerung[0].EinkaufsPreisDatum).format('DD.MM.YYYY') : null
      this.LetzterEPBasisWaehrung = this.storageData && this.storageData.Lagerung[0] ? this.storageData.Lagerung[0].LetzterEPBasisWaehrung !== null ? parseFloat(parseFloat(this.storageData.Lagerung[0].LetzterEPBasisWaehrung).toFixed(2)) : null : null
      this.LetzterEPDatum = this.storageData && this.storageData.Lagerung[0] ? this.storageData.Lagerung[0].LetzterEPDatum : null
      this.LetzterEPDatumFormatted = this.storageData && this.storageData.Lagerung[0] && this.storageData.Lagerung[0].LetzterEPDatum ? moment(this.storageData.Lagerung[0].LetzterEPDatum).format('DD.MM.YYYY') : null
      this.LetzterEP = this.storageData && this.storageData.Lagerung[0] ? this.storageData.Lagerung[0].LetzterEP !== null ? parseFloat(parseFloat(this.storageData.Lagerung[0].LetzterEP).toFixed(2)) : null : null
      this.LetzterEPWaehrung = this.storageData && this.storageData.Lagerung[0] ? this.storageData.Lagerung[0].LetzterEPWaehrung : null
      this.InventarPreis = this.storageData && this.storageData.Lagerung[0] ?  this.storageData.Lagerung[0].InventarPreis !== null ? parseFloat(parseFloat(this.storageData.Lagerung[0].InventarPreis).toFixed(2)) : null : null
      this.InventarPreisDatum = this.storageData && this.storageData.Lagerung[0] ? this.storageData.Lagerung[0].InventarPreisDatum : null
      this.InventarPreisDatumFormatted = this.storageData && this.storageData.Lagerung[0] && this.storageData.Lagerung[0].InventarPreisDatum ? moment(this.storageData.Lagerung[0].InventarPreisDatum).format('DD.MM.YYYY') : null
      this.KalkulationsPreis = this.storageData && this.storageData.Lagerung[0] ? this.storageData.Lagerung[0].KalkulationsPreis !== null ? parseFloat(parseFloat(this.storageData.Lagerung[0].KalkulationsPreis).toFixed(2)) : null : null
      this.KalkulationsPreisDatum = this.storageData && this.storageData.Lagerung[0] ? this.storageData.Lagerung[0].KalkulationsPreisDatum : null
      this.KalkulationsPreisDatumFormatted = this.storageData && this.storageData.Lagerung[0] && this.storageData.Lagerung[0].KalkulationsPreisDatum ? moment(this.storageData.Lagerung[0].KalkulationsPreisDatum).format('DD.MM.YYYY') : null

      const form: any = this.$refs['form']
      form.resetValidation()
    },

    resetData (): void {
      this.Lager = this.storageMetaData && this.storageMetaData.Lager[0] ? this.storageMetaData.Lager[0].ID : null
      this.Lagerfach = null
      this.Bevorzugt = false
      this.Laenge = 0.000
      this.Hoehe = 0.000
      this.Breite = 0.000
      this.Gewicht = 0.000
      this.Bestand = 0.000
      this.Einheit = this.selectedProductUnitId ? this.selectedProductUnitId : null
      this.Bestellt = 0.000
      this.Reserviert = 0.000
      this.Leitwaehrung = this.storageMetaData && this.storageMetaData.Waehrungen[0] ? this.storageMetaData.Waehrungen[0].ID : null
      this.Ertrag = null
      this.Aufwand = null
      this.Warenvorrat = null
      this.HauptKTR = null
      this.NebenKTR = null
      this.LagerKST = null
      this.WiAKST = null
      this.EinkaufsPreis = 0.00
      this.EinkaufsPreisDatum = null
      this.EinkaufsPreisDatumFormatted = ''
      this.LetzterEPBasisWaehrung = 0.00
      this.LetzterEPDatum = null
      this.LetzterEPDatumFormatted = ''
      this.LetzterEP = 0.00
      this.LetzterEPWaehrung = null
      this.LetzterEPWaehrung = ''
      this.InventarPreis = 0.00
      this.InventarPreisDatum = null
      this.InventarPreisDatumFormatted = ''
      this.KalkulationsPreis = 0.00
      this.KalkulationsPreisDatum = null
      this.KalkulationsPreisDatumFormatted = ''

      const form: any = this.$refs['form']
      form.resetValidation()
    }
  },

  mounted () {
    this.setData()
  }

})
